import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ApiService } from '../api.service';
import { SubscribeToTopicsRequest, SubscribeToTopicsResponse, UnsubscribeDeviceRequest, UnsubscribeDeviceResponse, UnsubscribedTopicsResponse } from 'src/app/models/core/topic/topic.model';

@Injectable({
  providedIn: 'root'
})
export class TopicApiService {
  private baseUrl = `${environment.api_server}/api/user`;

  constructor(
    private _http: HttpClient,
    private _api: ApiService
  ) { }


  public getUnsubscribedTopics(deviceId: number): Observable<UnsubscribedTopicsResponse> {
    const url = `${this.baseUrl}/unsubscribed-topics`;
    const params = { device_id: deviceId.toString() };
    return from(this._api.getAuthHeaders()).pipe(
      switchMap(headers =>
        this._http.get<UnsubscribedTopicsResponse>(url, { headers, params })
      )
    );
  }

  public subscribeToTopics(request: SubscribeToTopicsRequest): Observable<SubscribeToTopicsResponse> {
    const url = `${this.baseUrl}/subscribe-to-topics`;
    return from(this._api.getAuthHeaders()).pipe(
      switchMap(headers =>
        this._http.post<SubscribeToTopicsResponse>(url, request, { headers })
      )
    );
  }

  public getSubscribedTopics(deviceId: number): Observable<string[]> {
    const url = `${this.baseUrl}/subscribed-topics`;
    const params = { device_id: deviceId.toString() };
    return from(this._api.getAuthHeaders()).pipe(
      switchMap(headers =>
        this._http.get<string[]>(url, { headers, params })
      )
    );
  }

  public unsubscribeDevice(request: UnsubscribeDeviceRequest): Observable<UnsubscribeDeviceResponse> {
    const url = `${this.baseUrl}/unsubscribe-device`;
    return from(this._api.getAuthHeaders()).pipe(
      switchMap(headers =>
        this._http.post<UnsubscribeDeviceResponse>(url, request, { headers })
      )
    );
  }
}
